import React from 'react';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import { listingProps, track } from '../analytics/events.js';
import { toggleFavoriteListing, useFavorites } from './favorites.js';
import './favoriteButton.css';

// Heart that saves a listing as a favourite (listvy cards and the listing popup). A heart, not a star,
// since the star is the area rating (betyg) and the two would be easy to confuse. Filled red when saved.
const FavoriteButton = ({ listing, swedish, source, className = '' }) => {
    const { isFavorite } = useFavorites();
    const active = isFavorite(listing);
    const label = active
        ? (swedish ? 'Ta bort från favoriter' : 'Remove from favourites')
        : (swedish ? 'Spara som favorit' : 'Save as favourite');

    const handleClick = (event) => {
        // Cards open the popup on click and zoom the map on double click.
        event.stopPropagation();
        const on = toggleFavoriteListing(listing);
        track('listing.favorite', { on, source, ...listingProps(listing) });
    };

    return (
        <button
            type="button"
            className={`favorite-button${active ? ' is-active' : ''}${className ? ` ${className}` : ''}`}
            onClick={handleClick}
            onDoubleClick={(event) => event.stopPropagation()}
            aria-pressed={active}
            aria-label={label}
            title={label}
        >
            {active ? <FavoriteRoundedIcon fontSize="inherit" /> : <FavoriteBorderRoundedIcon fontSize="inherit" />}
        </button>
    );
};

export default FavoriteButton;
